import { render, staticRenderFns } from "./Attachment.html?vue&type=template&id=7395e1ab&scoped=true&"
import script from "./Attachment.js?vue&type=script&lang=js&"
export * from "./Attachment.js?vue&type=script&lang=js&"
import style0 from "./Attachment.scss?vue&type=style&index=0&id=7395e1ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7395e1ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
